import { render, staticRenderFns } from "./testResults.vue?vue&type=template&id=74b1b30a&scoped=true"
import script from "./testResults.vue?vue&type=script&lang=js"
export * from "./testResults.vue?vue&type=script&lang=js"
import style0 from "./testResults.vue?vue&type=style&index=0&id=74b1b30a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b1b30a",
  null
  
)

export default component.exports